export const socials = [
  { name: 'twitter', url: 'https://twitter.com/Nada_festival' },
  { name: 'instagram', url: 'https://www.instagram.com/nada_schoolfestival/' },
  { name: 'facebook', url: 'https://www.facebook.com/NadaSchoolFestival' },
  { name: 'youtube', url: 'https://www.youtube.com/@nada_schoolfestival' },
  { name: 'line', url: 'https://lin.ee/6agXgOH' },
];

export const links = [
  {
    name: 'home', ja: 'ホーム', url: '/', active: true,
  },
  {
    name: 'circles', ja: 'サークル', url: '/circles', active: true,
  },
  {
    name: 'stages', ja: 'ステージ', url: '/stages', active: true,
  },
  {
    name: 'goods', ja: 'グッズ', url: '/goods', active: true,
  },
  {
    name: 'download', ja: 'ダウンロード', url: '/download', active: true,
  },
];
